import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';

import Container from './styles';

const propTypes = {
  onPageChange: PropTypes.func.isRequired,
  pagesCount: PropTypes.number.isRequired,
  forcePage: PropTypes.number,
};

const defaultProps = {
  forcePage: 1,
};

/**
 * A página vem controlada por `forcePage` — e não por `initialPage` como no
 * portal — porque aqui a busca e a exclusão de usuário reposicionam a
 * listagem: sem isso o paginador continuaria destacando a página anterior.
 */
const Paginator = ({ onPageChange, pagesCount, forcePage }) => (
  <Container>
    <ReactPaginate
      pageCount={pagesCount}
      pageRangeDisplayed={3}
      marginPagesDisplayed={1}
      previousLabel="Anterior"
      nextLabel="Próxima"
      forcePage={forcePage < 1 ? 0 : forcePage - 1}
      containerClassName="container"
      pageClassName="item"
      previousClassName="item"
      nextClassName="item"
      pageLinkClassName="link"
      previousLinkClassName="link"
      nextLinkClassName="link"
      activeClassName="active"
      activeLinkClassName="active"
      onPageChange={({ selected }) => onPageChange(selected + 1)}
    />
  </Container>
);

Paginator.propTypes = propTypes;
Paginator.defaultProps = defaultProps;

export default Paginator;
